import React from 'react';
import { useParams } from 'react-router-dom';
import Games from './Games/Games';
import Journal from './Journal/Journal';
import News from './News/News';
import Contact from './Contact/Contact';

const BoardList = () => {
  const { category } = useParams();

  const renderBoardContent = () => {
    switch (category) {
      case 'games':
        return <Games />;
      case 'journal':
        return <Journal />;
      case 'news':
        return <News />;
      case 'contact_us':
        return <Contact />;
      default:
        return <div>게시판을 찾을 수 없습니다.</div>;
    }
  };

  return (
    <div className="board-main-wrap">
      <div className="board-title-wrap"></div>
      {renderBoardContent()}
    </div>
  );
};

export default BoardList;
